export function validateBaziInput({
  birthDate,
  birthHour,
  gender,
  timezoneOffsetMinutes
} = {}) {
  const errors = [];

  if (!(birthDate instanceof Date) || Number.isNaN(birthDate.getTime())) {
    errors.push('birthDate phai la Date hop le');
  } else if (birthDate.getFullYear() < 1900 || birthDate.getFullYear() > 2100) {
    errors.push('Chi ho tro nam sinh 1900-2100');
  }

  if (!Number.isFinite(birthHour) || birthHour < 0 || birthHour >= 24) {
    errors.push('birthHour phai tu 0-23.999… (co the la so thap phan)');
  }

  if (gender) {
    const normalized = gender.toString().toLowerCase();
    if (!['male', 'female', 'nam', 'nu', 'm', 'f'].includes(normalized)) {
      errors.push('gender phai la "male" hoac "female"');
    }
  }

  if (Number.isFinite(timezoneOffsetMinutes)) {
    if (timezoneOffsetMinutes < -720 || timezoneOffsetMinutes > 840) {
      errors.push('timezoneOffsetMinutes phai tu -720 den +840');
    }
  }

  if (errors.length > 0) {
    throw new Error(`[Bazi Validation] ${errors.join(', ')}`);
  }
}
